export const brandPanelTitle = 'Brands';
